import {SORespSesMessage} from '../../core/ses-message/so-resp-ses-message';
import {SesMessageCore} from './ses-message.core';
import {CEBase} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutSesMessageFormFields} from './put-ses-message-form-fields';
import { CESesMessageAttributes } from './ce-ses-message-attributes'


export class CESesMessageBase extends CEBase {

    public details: CESesMessageAttributes;
    public fromFields: PutSesMessageFormFields = new PutSesMessageFormFields();

    constructor(
        public parentEntityViewSpec: EntityViewSpecProtocol,
        public core: SesMessageCore,
        public entity: SORespSesMessage,
        public app: CommanderApp,
    ) {
        super(
            parentEntityViewSpec, core, entity, app,
        )
        this.details = new CESesMessageAttributes(
            parentEntityViewSpec,
            entity,
            app,
            this.fromFields
        );
        this.setAttributes();
        this.sortAttributes();
    }

    setAttributes() {

        this.attributes = []
        this.attributes.push(this.details.data)
        this.attributes.push(this.details.dateCreated)
        this.attributes.push(this.details.messageType)

    }
}